const React = require('react');
const {
  NotificationForm,
} = require('../../../../../../../dumb/AdminHelpers/AdminConfigs');

module.exports = () => {
  return (
    <NotificationForm />
  )
}
